<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/item">{{ $t('item_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('create_new_item') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះ</div>
                        <div class="error" v-if="!$v.model.Num.required">- សូមធ្វើការបញ្ជូលលេខកូដ</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="item-img-element">
                                <div class="side-left">
                                    <div class="card-img-top">
                                        <img :src="img" @click="$refs.file.click()" />
                                        <input type="file" ref="file" hidden accept="image/*" @change="fileChange"/>
                                    </div>
                                </div>
                                <div class="side-right">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                                        <label class="label-control blue">{{$t('item_name')}}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model"/>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="label-control blue">{{$t('item_name_en')}}
                                        </label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.NameEng"/>
                                        </div>
                                    </div>
                                    <div style="display: flex;">
                                        <div class="form-group" style="margin-right: 15px;">
                                            <label><input type="checkbox" v-model="model.CanSold"> {{$t('can_be_sold')}}</label>
                                        </div>
                                        <div class="form-group">
                                            <label><input type="checkbox" v-model="model.CanPurchase"> {{$t('can_be_purchase')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.Num.$error }">
                                        <label class="label-control blue">{{$t('barcode')}}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="$v.model.Num.$model"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('serialno') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="text" v-model="model.SerialNum">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('itemtype') }}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.ProductTypeId">
                                                <option value="1">{{$t('stock_assembly')}}</option>
                                                <option value="2">{{$t('service')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.CategoryId.$error }">
                                        <label class="label-control blue">{{ $t('item_category_list') }}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.CategoryId">
                                                <option value=""></option>
                                                <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.UomId.$error }">
                                        <label class="label-control blue">{{ $t('uom') }}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.UomId">
                                                <option v-for="ret in units" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('model') }}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.BrandId">
                                                <option value=""></option>
                                                <option v-for="ret in brands" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('price_sale') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.Price">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('cost') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.BeginCost">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('begin_stock') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.BeginQty">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('qty_alert') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.AlertQty">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.IncomeAccountId.$error }">
                                        <label class="label-control blue">{{ $t('income_acount_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.IncomeAccountName" @select="coaSelect(1, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.ExpenseAccountId.$error }">
                                        <label class="label-control blue">{{ $t('expense_account_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.ExpenseAccountName" @select="coaSelect(2, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.StockAccountId.$error }">
                                        <label class="label-control blue">{{ $t('stock_account_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.StockAccountName" @select="coaSelect(3, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('include_tax') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.IncludeTax">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{$t('vendor')}}</label>
                                        <div>
                                            <VendorDropdown @select="vendorSelected" :value="model.VendorName"></VendorDropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import CoaSelect from '../Accountings/CoaSelect';
import { VendorDropdown } from '../Vendors';
export default {
    components: { CoaSelect, VendorDropdown },
    data() {
        return {
            model: {
                Num: '',
                Name: '',
                NameEng: '',
                Description: '',
                ProductTypeId: '1',
                CategoryId: '',
                CanSold: true,
                CanPurchase: true,
                Image: '',
                BeginCost: 0,
                Price: 0,
                AlertQty: 0,
                BeginQty: 0,
                UomId: '',
                BrandId: '',
                IncludeTax: 0,
                StockAccountId: '',
                StockAccountName: '',
                ExpenseAccountId: '',
                ExpenseAccountName: '',
                IncomeAccountId: '',
                IncomeAccountName: '',
                VendorId: ''
            },
            categories: [],
            units: [],
            brands: [],
            img: '/img/no-image.svg',
            actionLink: 'item/save',
            formHead: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            isStore: true
        }
    },
    validations:{
        model: {
            Name: { required },
            Num: { required },
            CategoryId: { required },
            UomId: { required },
            StockAccountId: { required },
            ExpenseAccountId: { required },
            IncomeAccountId: { required }
        }
    },
    created: function() {
        this.initialize().then(() => {
            let id = this.$route.params.id;
            if(id != undefined){
                let loading = this.$loading.show();
                this.actionLink = 'item/update';
                this.$api().post('item/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        if(this.model.Image != null){
                            this.img = this.$base() + 'image/items/' + this.model.Image;
                        }
                        this.filterAccountName();
                    }
                }).finally(function() { loading.hide(); });
            }else {
                this.filterAccount();
            }
        });
    },
    methods: {
        initialize(){
            return new Promise((resolve) => {
                let loading = this.$loading.show();
                this.$api().post('item/initialize').then((res) => {
                    if(this.$isValid(res)){
                        var json = res.data.Json;
                        this.$store.state.accounts = json.Accounts;
                        this.categories = json.Categories;
                        this.units = json.Uoms;
                        this.brands = json.Brands;
                        resolve();
                    }
                }).finally(function(){ loading.hide(); });
            });
        },
        onSave() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                var loading = this.$loading.show();
                var formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                if (this.actionLink == 'item/update') {
                    formData.append("Id", this.model.Id);
                }
                for (var p in this.model) {
                    if (this.model[p] != null)
                        formData.append(p, this.model[p]);
                }
                this.$api().post(this.actionLink, formData, this.formHead).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.push("/item");
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        },
        fileChange(e) {
            this.img = URL.createObjectURL(e.target.files[0]);
        },
        coaSelect(n, sender){
            if(n == 1){
                this.model.IncomeAccountId = sender.Id;
                this.model.IncomeAccountName = sender.Name;
            }else if(n == 2){
                this.model.ExpenseAccountId = sender.Id;
                this.model.ExpenseAccountName = sender.Name;
            }else if(n == 3){
                this.model.StockAccountId = sender.Id;
                this.model.StockAccountName = sender.Name;
            }
        },
        filterAccount: function() {
            let accounts = this.$store.state.accounts;
            let isSale = false;
            let isAsset = false;
            let isExpense = false;
            for(var i = 0; i < accounts.length; i++){
                let item = accounts[i];
                if(item.Name == 'Sale'){
                    this.model.IncomeAccountId = item.Id;
                    this.model.IncomeAccountName = item.Name;
                    isSale = true;
                }else if(item.Name == 'Cost of Goods Sold'){
                    this.model.ExpenseAccountId = item.Id;
                    this.model.ExpenseAccountName = item.Name;
                    isExpense = true;
                }else if(item.Name == 'Inventory Asset'){
                    this.model.StockAccountId = item.Id;
                    this.model.StockAccountName = item.Name;
                    isAsset = true;
                }
                if(isSale && isAsset && isExpense){
                    break;
                }
            }
        },
        filterAccountName: function(){
            let accounts = this.$store.state.accounts;
            let isSale = false;
            let isAsset = false;
            let isExpense = false;
            for(var i = 0; i < accounts.length; i++){
                let item = accounts[i];
                if(item.Id == this.model.IncomeAccountId){
                    this.model.IncomeAccountName = item.Name;
                    isSale = true;
                }else if(item.Id == this.model.ExpenseAccountId){
                    this.model.ExpenseAccountName = item.Name;
                    isExpense = true;
                }else if(item.Id == this.model.StockAccountId){
                    this.model.StockAccountName = item.Name;
                    isAsset = true;
                }
                if(isSale && isAsset && isExpense){
                    break;
                }
            }
        },
        vendorSelected(item){
            this.model.VendorId = item.Id;
        }
    }
};
</script>
<style scoped>
    .item-img-element{
        display: flex;
    }
    .item-img-element .card-img-top{
        width: 105px;
        height: 105px;
        overflow: hidden;
        border-radius: 3px;
        border: 1px solid #ddd;
    }
    .item-img-element img{
        width: 105px;
        height: 105px;
    }
    .item-img-element .side-right{
        width: 100%;
        padding-left: 10px;
    }
</style>
